import React from 'react';
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom";
import { Typography, Grid, makeStyles } from '@material-ui/core';
import { useSelector } from "react-redux";
import { viewStyles } from 'theme';
import Card from "./Card";
import PerformanceMapTable from "./PerformanceMapTable";
import { isArray, filter } from "lodash";
import { getStatusData } from "helpers";
const useStyles = makeStyles(viewStyles);

const LocationPerformance = (props) => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const pageName = pathname.split("/")[4];
  const { setDetails, type, ...rest } = props;
  const { performance: perfomanceStats } = useSelector(({ sites }) => sites);

  let perfData = isArray(perfomanceStats) ? perfomanceStats : [];
  perfData = filter(perfData, {siteNum: type})
  perfData = perfData.map(d => {
    const data = getStatusData({
        ...d,
        actualHours: d.aheadOrBehind == "BEHIND" ? -(d.hours) : d.hours,
        hours: parseFloat(d.hours).toFixed(1)
    }, "actualHours");
    return {
        ...d,
        ...data
    };
  })

  const Title = () => {
    return (
      <Grid container alignItems='center' justifyContent="space-between" data-testid="locationPerformance">
        {
          <Typography variant="body1" color="primary">
            {t('location_performance')}
          </Typography>
        }
      </Grid>
    )
  }

  return (
    <Card cardtitle={<Title />} className={pageName === 'distribution' ? classes.customCard : classes.transparentCard}>
      <PerformanceMapTable data={perfData} setDetails={setDetails} type={type} perfTableRedirection={rest.perfTableRedirection} singleLocation={true} pageName={pageName} />
    </Card>
  );
}

export default LocationPerformance;